import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { crnaProfessionCode, locumsPhysicianProfessionCodes } from 'src/app/locums/locums-constants';
import { jobDetailsLoaded } from '../../store/selectors/job-details.selectors';
import { JobState } from '../../store/state/job-details.state';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-requirements',
    templateUrl: './locums-recruiter-requirements.component.html',
    styleUrls: ['./locums-recruiter-requirements.component.scss']
})
export class LocumsRecruiterRequirementsComponent implements OnInit {
    @Input() jobId: number;

    isLocumsPhysicianProfession$ = new BehaviorSubject<boolean>(false);
    isCRNA$ = new BehaviorSubject<boolean>(false);

    constructor(private readonly _store: Store<JobState>) {}

    ngOnInit(): void {
        this._store
            .select(jobDetailsLoaded)
            .pipe(untilDestroyed(this))
            .subscribe((e) => {
                if (e.success) {
                    this.isLocumsPhysicianProfession$.next(
                        locumsPhysicianProfessionCodes.includes(e.job?.professionId)
                    );
                    this.isCRNA$.next(e.job?.professionId === crnaProfessionCode);
                }
            });
    }
}
